{
  "translation": {
    "button": {
      "ok": "Ok",
      "cancel": "Cancel",
      "clear": "Clear",
      "login": "Login",
      "logout": "Logout",
      "delete": "Delete",
      "new": "New",
      "back": "Back",
      "save": "Save",
      "create": "Create",
      "export": "Export",
      "import": "Import",
      "upload": "Upload",
      "iframe": "IFrame",
      "open": "Open",
      "newTab": "New Tab",
      "search": "Search",
      "refresh": "Refresh",
      "compare": "Compare",
      "publish": "Publish",
      "discard": "Discard",
      "deleteAll": "Delete All",
      "download": "Download",
      "generate": "Generate"
    },
    "tooltip": {
      "enableOptional": "Checked implies optional features will be shown in the configurator."
    },
    "dialogBox": {
      "error": "Error",
      "success": "Success",
      "ConnectionError": "Connection Error"
    },
    "labels": {
      "lovOptions": "LOV Options ({{name}})",
      "description": "Description",
      "name": "Name",
      "email": "Email",
      "userManagement": "User Management",
      "roleManagement": "Role Management",
      "apiKeyManagement": "API Key Management",
      "applicationManagement": "Application Management",
      "featureFlagsManagement": "Feature Flags Management",
      "personalDetails": "Personal Details",
      "roleAssociation": "Role Association",
      "createUser": "Create User",
      "editUser": "Edit User",
      "isAdmin": "Admin",
      "createRole": "Create Role",
      "editRole": "Edit Role",
      "isDefault": "Default",
      "createApiKey": "Create API key",
      "editApiKey": "Edit API key",
      "permission": "Permission",
      "read": "Read",
      "write": "Write",
      "yes": "Yes",
      "no": "No",
      "key": "Key",
      "applicationUrl": "Application URL",
      "access": "Permission",
      "userEmail": "Service User",
      "emailId": "Email",
      "isService": "Service User",
      "isPdm": "PDM User",
      "isAce": "Ace User",
      "roles": "Roles",
      "accessType": "Permission",
      "isActive": "Active",
      "isHidden": "Hidden",
      "isEditable": "Editable",
      "isVisible": "Show",
      "channels": "Channels",
      "deleteConfirm": "Confirm Delete",
      "administration": "Administration",
      "dataMaintainance": "Data Maintenance",
      "featureFlags": "Feature Flags",
      "flagName": "Flag Name",
      "applicationName": "Application Name",
      "application": "Application Name",
      "page": "Page",
      "configuration": "Configuration",
      "configurationId": "Configuration Id",
      "token": "Token",
      "language": "Language",
      "apiKey": "API Key",
      "country": "Country",
      "none": "None",
      "headerLess": "Header Less",
      "note": "Note",
      "copyApiKey": "I have copied the key.",
      "product": "Product",
      "id": "Id",
      "code": "Code",
      "productCode": "Product Code",
      "languages": "Languages",
      "recordsPerPage": "Records",
      "materialCode": "Material Code",
      "countryCode": "Country Code",
      "currencyCode": "Currency Code",
      "price": "Price",
      "editPriceListMap": "Edit Price List Mapping",
      "editLanguageAssociation": "Edit Language Association",
      "materialImages": "Images",
      "languageCode": "Language Code",
      "shortSalesText": "Short Sales Text",
      "longSalesText": "Long Sales Text",
      "view": "View",
      "sc": "SC Code",
      "pd": "PD Code",
      "bs": "BS Code",
      "bu": "BU Code",
      "mag": "MAG Code",
      "ag": "AG Code",
      "image": "Image",
      "languageManagement": "Language Management",
      "createLanguage": "Create Language",
      "editLanguage": "Edit Language",
      "supportDetails": "Support Details",
      "browserCompatibility": "Browser Compatibility",
      "enableOptional": "Enable Optional Features",
      "apikeyDetails": "API key Details",
      "feature": "Features",
      "message": "Message",
      "url": "URL",
      "create": "Create",
      "edit": "Edit",
      "map": "Price Map",
      "newMap": "New Price Map",
      "productId": "Product Code",
      "productDescription": "Product Description",
      "agCode": "Ag Code",
      "packageType": "Package Type",
      "countries": " Countries",
      "marketManagement": "Market Management",
      "createMarket": "Create Market",
      "editMarket": "Edit Market",
      "markets": "Markets",
      "market": "Market",
      "state": "State",
      "createdBy": "Created By",
      "modifiedBy": "Modified By",
      "deletedBy": "Deleted By",
      "createdOn": "Created On",
      "modifiedOn": "Modified On",
      "versionId": "Version Id",
      "releaseId": "Release Id",
      "deletedOn": "Deleted On",
      "lastLogin": "Last Login",
      "countryName": "Country Name",
      "packagePath": "Package Path",
      "createdFromName": "Created From Name",
      "createdFromId": "Created From Id",
      "editMarketAssociation": "Edit Market Association",
      "permissions": "Permissions",
      "group": "Group",
      "resource": "Resource",
      "privileges": "Privileges",
      "properties": "Properties",
      "compare": "Compare",
      "details": "Details",
      "lastUpdatedOn": "Last Updated On",
      "notificationManagement": "Notification Management",
      "queueManagement": "Queue Management",
      "releaseManagement": "Product Release Management",
      "productVersionMappingManagement": "Product Version Mapping",
      "notifications": "Notification",
      "reports": "Reports",
      "type": "Type",
      "targetId": "Target Id",
      "action": "Action",
      "refresh": "Refresh",
      "active": "Active",
      "status": "Status",
      "processedOn": "Processed On",
      "log": "Log",
      "sync": "Sync",
      "retrigger": "Retrigger",
      "userAccessType": "Access Types",
      "propertyManagement": "Property Management",
      "applicability": "Applicability",
      "listOfValues": "List of Values",
      "origin": "Origin",
      "default": "Default",
      "configit": "Configit",
      "pdm": "PDM",
      "option": "Option",
      "selectionType": "Selection Type",
      "inactive": "InActive",
      "actions": "Actions",
      "valueType": "Value Type",
      "restrictUpdate": "(Selection is irreversible)",
      "values": "Values",
      "channel": "Channel",
      "views": "View",
      "isLocal": "IsLocal",
      "multiNumericManagement": "Multi-Numeric Management",
      "others": "Others",
      "columns": "Columns",
      "filters": "Filters",
      "source": "Source",
      "txnId": "Txn Id",
      "user": "User",
      "syncedOn": "Synced On",
      "error": "Error",
      "activities": "Activities",
      "version": "Version",
      "startedOn": "Started On",
      "remarks": "Remarks",
      "rules": "Rules",
      "effectivity": "Effectivity",
      "salestext": "Sales Text",
      "selectAll": "All",
      "download": "Download",
      "isRequired": "Mandatory",
      "fromDate": "From",
      "toDate": "To",
      "fileName": "File Name",
      "reportManagement": "Reports Management",
      "descopeList": "Descope List",
      "coe": "COE",
      "procosForPpl": "ProCoS for PPL",
      "allCommercialItems": "All Commercial Items"
    },
    "header": {
      "image": "Image",
      "price": "Price",
      "productHierarchy": "Product Hierarchy",
      "languageAssociation": "Language Association",
      "salesText": "Sales Text",
      "roles": "Role",
      "users": "User",
      "apikeys": "API key",
      "applications": "Application",
      "channels": "Channels",
      "languages": "Language",
      "associatedLanguages": "Associated Languages",
      "priceListMap": "Price List Map",
      "productCatalog": "Product Catalog",
      "internalProductCatalog": "Internal Product Catalog",
      "productConfiguration": "Product Configuration",
      "archivedConfiguration": "Archived Configuration",
      "marketAssociation": "Market Association",
      "countries": "Countries",
      "markets": "Market",
      "associatedMarkets": "Associated Markets",
      "featureFlags": "Feature Flag",
      "images": "Images",
      "properties": "Property",
      "propertyAssociation": "Property Association Management",
      "featurePropertyAssociation": "Feature Property Association",
      "technicalInfo": "Technical Part Information",
      "views": "View",
      "multiNumericFeature": "Multi Numeric",
      "notification": "Notification",
      "queue": "Queue",
      "productRelease": "Product Release",
      "productVersionMapping": "Product Version Mapping"
    },
    "reports": {
      "descopeList": "Descope List",
      "extractForCoe": "Extract for CoE"
    },
    "footer": {
      "env": "Env",
      "termsAndConitons": "Terms & Conditions",
      "release": "R",
      "sprint": "SP",
      "build": "Build",
      "branch": "Branch",
      "date": "Date"
    },
    "messages": {
      "error": {
        "204": "No configuration changes to notify.",
        "400": "Invalid data.",
        "401": "Session expired. Please login again.",
        "403": "You dont have access. Please contact administrator.",
        "404": "Resource not found.",
        "500": "Some Error occured. Please try again later."
      },
      "success": {
        "create": "Created successfully!",
        "update": "Updated successfully!",
        "delete": {
          "general": "Deleted successfully",
          "users": "Successfully deleted ({{length}}) user(s) : {{list}}",
          "roles": "Successfully deleted ({{length}}) role(s) : {{list}}",
          "apikeys": "Successfully deleted ({{length}}) apikey(s) : {{list}}",
          "applications": "Successfully deleted ({{length}}) application(s) : {{list}}",
          "languages": "Successfully deleted ({{length}}) language(s) : {{list}}",
          "markets": "Successfully deleted ({{length}}) market(s) : {{list}}",
          "featureFlags": "Successfully deleted ({{length}}) feature flag(s) : {{list}}",
          "properties": "Successfully deleted ({{length}}) property(s) : {{list}}",
          "multiNumeric": "Successfully deleted ({{length}}) multiNumeric feature(s) : {{list}}",
          "notification": "Successfully deleted ({{length}}) notification(s) : {{list}}",
          "prices": "Successfully deleted prices"
        },
        "import": "File upload successful. Importing Data ...",
        "upload": {
          "general": "Data uploaded successfully!",
          "productHierarchy": "Data upload successful.<1/>Please use the 'Compare' button to view and publish the changes.",
          "technicalInfo": "<1>Success</1> - Data import successful for {{file}} at {{timestamp}}"
        },
        "publish": "Data published successfully!",
        "discard": "Data discarded successfully!",
        "retriggeredSuccessfully": "Retriggered Successfully!"
      },
      "fail": {
        "create": "Creation failed!",
        "update": "Updation failed!",
        "download": "Download failed!",
        "delete": {
          "general": "Deletion failed",
          "users": "Deletion failed for user(s) ({{length}}): {{list}}",
          "roles": "Deletion failed for role(s) ({{length}}): {{list}}",
          "apikeys": "Deletion failed for apikey(s) ({{length}}): {{list}}",
          "applications": "Deletion failed for application(s) ({{length}}): {{list}}",
          "languages": "Deletion failed for languages(s) ({{length}}): {{list}}",
          "markets": "Deletion failed for market(s) ({{length}}): {{list}}",
          "featureFlags": "Deletion failed for feature flag(s) ({{length}}): {{list}}",
          "properties": "Deletion failed for property(s) ({{length}}): {{list}}",
          "prices": "Deletion failied for prices",
          "notification": "Deletion failed for notification(s) ({{length}}): {{list}}",
          "multiNumeric": "Deletion failed for multi numeric feature(s) ({{length}}): {{list}}"
        },
        "export": "Export failed!",
        "upload": "Upload failed!",
        "import": "Import failed!",
        "publish": "Publish failed!",
        "discard": "Discard failed!",
        "getDetails": "Some error occured. Unable to fetch details!",
        "fileSize": "File size cannot exceed {{size}}MB",
        "fileFormat": "Only file with {{format}} extension is accepted",
        "importWithFileInfo": "<1>Failed</1> - Data import failed for {{file}} at {{timestamp}}.",
        "importWithFileInfoAndLog": "<1>Failed</1> - Data import failed for {{file}} at {{timestamp}}. Please check the downloaded log file {{logFileName}} for more details.",
        "configurationId": "Configuration Id ({{id}}) not found",
        "fileName": "{{fileName}} - Name should be less than {{fileNameSize}} characters",
        "retriggeredFailed": "Retriggered Failed!",
        "generate": "Generation failed!"
      },
      "confirmation": {
        "delete": {
          "applications": "Deleting '{{applicationNames}}'<br/>- InActivates all its corresponding feature flags<br/>- Deletes all its associations with the API key<br/><br/>This action cannot be reversed.<br/><br/>Are you sure you want to delete?",
          "featureFlags": "Deleting '{{featureFlagNames}}'<br/>- Deletes all its associations with the API key<br/><br/>This action cannot be reversed.<br/><br/>Are you sure you want to delete?"
        }
      },
      "reports": {
        "generateTriggered": "Report generation triggered successfully."
      },
      "login": "Please login again.",
      "session": "Session expired.",
      "unauthenticated": "User is not logged in. Please login. If problem persists, please contact your administrator.",
      "tryAgain": "Please try again after some time.",
      "nameErrorMessage": "Please enter a valid name",
      "codeErrorMessage": "Please enter a valid code",
      "emailErrorMessage": "Invalid email format",
      "urlErrorMessage": "Invalid URL format",
      "deleteConfirmation": "Are you sure you want to delete?",
      "deletePricesConfirmation": "Prices will be deleted permanently.<br/>Are you sure you want to continue?",
      "copyApiKeyMessage": "Retrieving the key is not possible once this dialog is closed. Copy the key to close this dialog.",
      "noServiceUserAvailable": "No service user available",
      "noSearchRecords": "No records found for '{{searchValue}}'",
      "noDataFound": "No data found.",
      "errorParsingLog": "Error parsing log",
      "noCountriesFound": "No countries found",
      "noApplicationsFound": "No applications found",
      "browserNotSupported": "Browser not supported",
      "browserNotSupportedMessage": "You are using a browser or browser version that is not officially supported.<1/><1/>You can continue to use the application or use one of the latest version of the supported browser for best experience.",
      "supportedBrowsers": "Supported browsers are",
      "100LimitErrorMessage": "Please limit the text to 100 characters",
      "deleteLimitMessage": "Max. {{limit}} records can be deleted at a time.",
      "logoutMessage": "User is logged out. Please login to the application again.",
      "descriptionErrorMessage": "Please enter a valid description",
      "pageErrorMessage": "Please enter a valid page",
      "maxLimitErrorMessage": "Only {{limit}} characters allowed.",
      "minLimitErrorMessage": "Minimum {{limit}} characters required.",
      "invalidInputErrorMessage": "Invalid input."
    }
  }
}